export default __webpack_public_path__ + "static/media/manage_orders.0c75ddbd.svg";